<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="4">
					<div class="qms-search-input sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001317') }}</span>
						<div class="search-option-wrapper__normal">
							<el-input
								v-model="schMesEqipNo"
								:label="getMessage_('QWCC001317')"
								:placeholder="getMessage_('QWCC001317')"
								:clearable="true"
							></el-input>
						</div>
					</div>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList(schMesEqipNo)" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import _ from 'lodash';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/mmc/mmcm/MesInfo/store/helpers';
export default {
	props: { scrId: { type: String, default: '' }, mesEqipNo: { type: String, default: '' } },
	data() {
		return {
			schMesEqipNo: ''
		};
	},
	created() {
		this.schMesEqipNo = this.mesEqipNo;
	},
	watch: {
		mesEqipNo() {
			this.schMesEqipNo = this.mesEqipNo;
		},
		schMesEqipNo: _.debounce(function (value) {
			//디바운스 처리 + 바코드 기기로 입력하면 바로 검색 되게 하기 위해서
			if (value.length > 9) {
				const searchWord = value.substr(-10);
				this.schMesEqipNo = searchWord.substr(0, 9);
				this.searchList(this.schMesEqipNo);
			}
		}, 300)
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async searchList(schMesEqipNo = this.popupData.mesEqipNo) {
			this.$sf_toggleLoading(true);
			try {
				const response = await this.getMesInfoOne_(schMesEqipNo);
				if (response.code == 0) {
					await this.getHistoryList_(schMesEqipNo); // 교정이력 목록 조회
					await this.getHisPrbmList_(schMesEqipNo); // 이상이력 목록 조회
					if (this.popupData.calWayCd === null || this.popupData.calWayCd === '') {
						this.onChangeParam({ key: 'calWayCd', value: 'OSCP' }); //사외업체
					}
				} else {
					this.schMesEqipNo = response.schMesEqipNo;
					throw new Error(response.message);
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || error });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		onChangeParam({ key, value }) {
			this.onChangeParam_({ key, value });
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
